/* global jQuery, pageInformation, sgData, SGEvent */

/**
 * Helper functions and events for sgData object.
 * See https://shopgate.atlassian.net/wiki/x/Y4dO for more information
 */

(function ($) {
  // Define event names
  var EVENT_VIEW_APPEAR = 'sgViewAppear';
  var EVENT_PRODUCT_UPDATE = 'sgProductUpdate';
  var EVENT_ADD_TO_CART = 'sgAddToCart';
  var EVENT_CART_UPDATE = 'sgCartUpdate';
  var EVENT_DATA_UPDATE = 'sgDataUpdate';

  SGEvent.Broadcast.register('updateSgData', 'userLoggedIn', 'userLoggedOut');

  function init() {
    updatePageInfo();
  }

  /**
   * Refresh sgData.page information
   */
  function updatePageInfo(override) {
    var pageChanges = {
      title: document.title,
    };

    var possibleKeysForOverride = ['name'];

    if (typeof override === 'object') {
      $.each(override, function (key, value) {
        if (possibleKeysForOverride.indexOf(key) !== -1) {
          pageChanges[key] = value;
        }
      });
    }

    $.extend(window.sgData.page, pageChanges);

    triggerEvent(EVENT_DATA_UPDATE, window.sgData);
  }

  /**
   * Helper to trigger custom event
   *
   * @param name
   * @param data
   */
  function triggerEvent(name, data) {
    var event;

    try {
      event = new CustomEvent(name, {
        detail: data,
      });
    } catch (e) {
      // Fallback for IE
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(name, true, true, data);
    }

    document.dispatchEvent(event);
  }

  /**
   * Prepares sgData.product
   *
   * @param {Object} product
   * @param {Object} [priceInfo] Optional object with additional price information
   * @returns {{
   *    uid: (.data.product_number|*),
   *    itemNumber: *, name: *,
   *    amount: {
   *      currency: *,
   *      net: *,
   *      gross: *,
   *      taxRate: *,
   *      tax: *,
   *      stockQuantity: *
   *    }
   *  }}
   */
  function sanitizeProductForSgData(product, priceInfo) {
    const amount = {
      currency: product.currency_id,
      taxRate: product.tax_percent,
    };

    if (priceInfo) {
      amount.net = formatAmount(priceInfo.unit_amount_display_net);
      amount.gross = formatAmount(priceInfo.unit_amount_display_gross);
      amount.tax = formatAmount(
        priceInfo.unit_amount_display_gross - priceInfo.unit_amount_display_net
      );
      amount.displayPrice = formatAmount(priceInfo.unit_amount_display);
      amount.displayPriceStriked = formatAmount(
        priceInfo.strike_price_display ||
        priceInfo.unit_amount_display
      );
    } else {
      amount.net = formatAmount(product.unit_amount_net);
      amount.gross = formatAmount(product.unit_amount_with_tax);
      amount.tax = formatAmount(product.unit_amount_with_tax - product.unit_amount_net);
      amount.displayPrice = formatAmount(product.unit_amount_display);
      amount.displayPriceStriked = formatAmount(
        product.strike_price_display ||
        product.unit_amount_display
      );
    }

    const needToSplitTags = product.tags && typeof product.tags.split === 'function';
    const tags = needToSplitTags ? product.tags.split(',') : [];

    return {
      uid: product.product_number,
      productNumber: product.product_number_public,
      name: product.name,
      stockQuantity: product.stock_quantity,
      identifiers: {
        ean: product.ean || null,
      },
      amount,
      tags,
    };
  }

  /**
   * Sanitizes any given product data object or array to the specified sgData.product structure
   * @param {Object|Array} data Array or Object containing "raw" product data
   * @returns {{products: Array}} Sanitized product data
   */
  function sanitizeProductsForSgData(data) {
    var products = [];
    if (typeof data !== 'undefined' && data.products) {
      if (Array.isArray(data.products)) {
        data.products.forEach(function (element) {
          var product = sanitizeProductForSgData(element.product, element.product_price_info);

          if (element.quantity) {
            product.quantity = element.quantity;
          }

          products.push(product);
        });
      } else if (typeof data.products === 'object') {
        for (var i in data.products) {
          if (data.products[i].product) {
            var productData = data.products[i];
            var sanitizedProduct = sanitizeProductForSgData(
              productData.product,
              productData.product_price_info
            );
            if (productData.product.quantity) {
              sanitizedProduct.quantity = productData.product.quantity;
            }

            products.push(sanitizedProduct);
          }
        }
      }
    }

    return {
      products: products,
    };
  }

  /**
   * Helper to format amounts
   *
   * @param amount
   * @returns {string|*}
   */
  function formatAmount(amount) {
    return $.shopgate.formatNumber(amount / 100, 2, '.', '');
  }

  // VIEW APPEAR
  SGEvent.registerCallback('viewDidAppear', function () {
    // check if app
    if (window.checkClientIsShopgateApp()) {
      var sgDataReduced = JSON.parse(window.localStorage.getItem('sgDataReduced'));
      // For Shopgate Connect we always want to get fresh user data.
      if (
        window.isShopgateCloud
        || (
          !sgDataReduced
          || typeof sgDataReduced === 'undefined'
        )
      ) {
        _updateSgData(_triggerViewAppear);
      } else {
        _updateSgDataObject(sgDataReduced);
        _triggerViewAppear();
      }
    } else {
      _triggerViewAppear();
    }

    function _triggerViewAppear() {
      triggerEvent(EVENT_VIEW_APPEAR);
    }
  }).registerCallback('userLoggedIn, userLoggedOut', function () {
    // we don't want every page to do the request
    if (pageInformation.pageId === 'index') {
      _updateSgData(function (data) {
        SGEvent.Broadcast.updateSgData(data);
      });
    }
  }).registerCallback('updateSgData', function (data) {
    _updateSgDataObject(data);
  });

  function _updateSgData(callback) {
    $.shopgate.ajax({
      url: 'sgapi:ajax_get_sg_data',
      success: function (data) {
        var sgDataReduced = data.data || {};

        if (data.success) {
          delete sgDataReduced.page;
          delete sgDataReduced.tracking;

          window.localStorage.setItem('sgDataReduced', JSON.stringify(sgDataReduced));
          _updateSgDataObject(sgDataReduced);
        }

        if (typeof callback === 'function') {
          callback(sgDataReduced);
        }
      },
    });
  }

  function _updateSgDataObject(data) {
    var sgDataBefore = $.extend(true, {}, sgData);

    if (data.user) {
      window.sgData.user = data.user;
    }

    if (data.favouriteList) {
      window.sgData.favouriteList = sanitizeProductsForSgData(data.favouriteList);
      delete data.favouriteList;
    }

    window.sgData = $.extend(true, {}, window.sgData, data);

    // Trigger update event when sgData was changed
    if (!$.shopgate.areObjectsEqual(window.sgData, sgDataBefore)) {
      triggerEvent(EVENT_DATA_UPDATE, window.sgData);
    }
  }

  // PRODUCT UPDATE
  $(document).on('shopgateFramework.dataUpdate.product', function (e, data) {
    // Validate event data
    if (!data.product) {
      return;
    }

    // Update page info (link changes when another child is selected)
    updatePageInfo();

    // Format product data into right format
    var product = sanitizeProductForSgData(data.product.product, data.product_price_info);

    // Update sgData
    window.sgData.product = product;

    // Trigger tracking event
    triggerEvent(EVENT_PRODUCT_UPDATE, product);
    triggerEvent(EVENT_DATA_UPDATE, window.sgData);
  });

  // ADD TO CART
  $(document).on('shopgateFramework.product.addedToCart', function (e, data) {
    // Validate event data
    if (!data.products) {
      return;
    }

    // Build tracking event data
    var eventData = sanitizeProductsForSgData(data);

    // Trigger tracking event
    triggerEvent(EVENT_ADD_TO_CART, eventData);
    triggerEvent(EVENT_DATA_UPDATE, window.sgData);
  });

  // CART UPDATED
  $(document).on('shopgateFramework.dataUpdate.cart', function (e, data) {
    // Validate event data
    if (!data.cart) {
      return;
    }

    // Update sgData on cart page
    if (window.sgData && window.sgData.hasOwnProperty('cart')) {
      window.sgData.cart = data.cart;
    }

    // trigger plain javascript event
    triggerEvent(EVENT_CART_UPDATE, data.cart);
    triggerEvent(EVENT_DATA_UPDATE, window.sgData);
  });

  // UPDATE ANY SG DATA
  $(document).on('shopgateFramework.sgData.updateData', function (e, data) {
    if (data && typeof data === 'object') {
      _updateSgDataObject(data);
    }
  });

  if (typeof $.sgHelpers.historyChange === 'function') {
    var historyChanger = new $.sgHelpers.historyChange();

    $(historyChanger).on(historyChanger.getEvents().SHOPGATE_HISTORY_URL_CHANGED, function () {
      var currentSlug = this.getCurrentSlug();
      var newName = window.sgData.page.name;

      if (currentSlug.indexOf('checkout_payment') !== -1) {
        var newNameExtensionArr = currentSlug.split('checkout_payment/');
        var newNameExtension;
        var sgDataNameArr;

        newNameExtensionArr.shift();
        newNameExtension = newNameExtensionArr.join('/');
        sgDataNameArr = newName.split('-');

        sgDataNameArr[0] = $.trim(sgDataNameArr[0]);
        sgDataNameArr[1] = $.trim(newNameExtension);

        if (sgDataNameArr[1].length) {
          newName = sgDataNameArr.join(' - ');
        } else {
          newName = sgDataNameArr[0];
        }

        updatePageInfo({
          name: newName,
        });
      }
    });
  }

  init();
})(jQuery);



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-sgdata-helper.js